// src/campaigns/configs/campaigns.2027.ts

import { buildCampaignsForYear } from "./campaign-factory";

export const campaigns2027 = buildCampaignsForYear(2027);
